module.exports = __webpack_public_path__ + "static/media/clientPhoto5.a770c66a.png";